var map = {
	"./apple-laurel-da-DK.svg": 48124,
	"./apple-laurel-de-DE.svg": 97582,
	"./apple-laurel-en-GB.svg": 1876,
	"./apple-laurel-en-US.svg": 52095,
	"./apple-laurel-es-ES.svg": 90264,
	"./apple-laurel-es-MX.svg": 37131,
	"./apple-laurel-fr-FR.svg": 97808,
	"./apple-laurel-it-IT.svg": 90150,
	"./apple-laurel-nb-NO.svg": 96509,
	"./apple-laurel-nl-NL.svg": 3788,
	"./apple-laurel-pl-PL.svg": 46692,
	"./apple-laurel-pt-BR.svg": 19448,
	"./apple-laurel-pt-PT.svg": 34276,
	"./apple-laurel-sv-SE.svg": 44981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;